import styled from 'styled-components';
import { getSizeBy } from '../../../../../src/styled/utils';
export const StyledTopSubtitle = styled.div `
  display: flex;
  flex-flow: row wrap;
  gap: ${getSizeBy(3)};
  align-items: center;
  width: 100%;
  padding: ${getSizeBy(3)};
`;
